import { CustomerRelationshipManager } from "../CustomerRelationshipManager";
import { DataSource, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutCRMMultiProfile extends Layout {
    layoutCRM: CustomerRelationshipManager;
    sourceCallListProfile: DataSource;
    tabProfile: Tab;
    tabsetCallListProfiles: Tabset;
}
